/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setPasscode} from '../api'

export const useMutationSetPasscode = createReactQueryMutationHook('setPasscode', setPasscode)
